import React from "react";
import { FileText, Lock } from "lucide-react";
import HelpTip from "src/stage/HelpTip";

// AUTO-WA-39: what replaces the message box once the 24-hour window has
// closed, explained for someone new to WhatsApp Business.
export default function WindowClosed({ name, onTemplateClick, neverWrote = false }) {
  const who = name ? name.split(" ")[0] : "this customer";
  return (
    <div className="wa-closed" role="region" aria-label="Reply window closed">
      <span className="wa-closed-icon" aria-hidden="true"><Lock size={18} /></span>
      <div className="ws-grow">
        <strong>
          {neverWrote ? `${who} hasn’t messaged you yet` : `It’s been more than 24 hours since ${who} last wrote`}
          <HelpTip term="window" align="right" />
        </strong>
        <p>WhatsApp only lets businesses start a chat with an approved template. Once {who} replies, you can type any message again for 24 hours.</p>
      </div>
      <button type="button" className="ws-btn ws-btn--primary" onClick={onTemplateClick} aria-label="Send Template">
        <FileText size={15} />Send a template
      </button>
    </div>
  );
}
